module.exports = __webpack_public_path__ + "static/media/pic1.a9f0624b.webp";